export default defineNuxtRouteMiddleware(async (to, from) => {
    if (useAuthStore().user) {
        const supabaseUser = useSupabaseUser()
        if (supabaseUser.value) {
            return navigateTo('/')
        }
    }
})
